import { ReactNode } from "react"
import { Helmet } from "react-helmet"

export type BaseLayoutType = {
    children: ReactNode
    seo: {
        metaTitle: string
        metaDescription?: string
        canonicalUrl?: string
        metaImage?: string
        structuredData?: JSON
        metaRobots: string
    }
}

export default function BaseLayout({ children, seo }: BaseLayoutType) {
    return (
        <div className="grow w-full flex flex-col items-center justify-start bg-base-100 text-[#f2e6da]">
            <Helmet>
                {/* Standard SEO */}
                <title>{seo?.metaTitle ?? "Wicode GmbH - Softwareentwicklung"}</title>
                <meta name="description" content={seo?.metaDescription ?? "Wicode GmbH - Softwareentwicklung"} />
                <meta name="robots" content={seo?.metaRobots ?? "index, follow, allow"} />

                {/* Open Graph (für Facebook, LinkedIn etc.) */}
                <meta property="og:title" content={seo?.metaTitle} />
                <meta property="og:description" content={seo?.metaDescription} />
                <meta property="og:url" content={seo?.canonicalUrl} />
                <meta property="og:image" content={seo?.metaImage ?? "/public/wicode_logo_sm_no_bg.png"} />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={seo?.metaTitle} />
                <meta name="twitter:description" content={seo?.metaDescription} />
                <meta name="twitter:image" content={seo?.metaImage ?? "/public/wicode_logo_sm_no_bg.png"} />

                {/* JSON-LD Structured Data */}
                {seo?.structuredData && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seo?.structuredData) }} />}
            </Helmet>
            {children}
        </div>
    )
}
